import type { TSelector } from "../../../i18n/types";

// Pattern B (i18n): selector functions execute in the consumer's `t` scope.
// Consumers bind `useTranslation(["advertising", ...])` and pass these to `t(...)` at render time.
// Use the FLAT form ($[…], no namespace prefix).
export const WEEKDAYS: readonly TSelector[] = [
  ($) => $.advertising["Monday"],
  ($) => $.advertising["Tuesday"],
  ($) => $.advertising["Wednesday"],
  ($) => $.advertising["Thursday"],
  ($) => $.advertising["Friday"],
  ($) => $.advertising["Saturday"],
  ($) => $.advertising["Sunday"],
] as const;

export const HOURS: readonly TSelector[] = [
  ($) => $.advertising["12am"],
  ($) => $.advertising["1am"],
  ($) => $.advertising["2am"],
  ($) => $.advertising["3am"],
  ($) => $.advertising["4am"],
  ($) => $.advertising["5am"],
  ($) => $.advertising["6am"],
  ($) => $.advertising["7am"],
  ($) => $.advertising["8am"],
  ($) => $.advertising["9am"],
  ($) => $.advertising["10am"],
  ($) => $.advertising["11am"],
  ($) => $.advertising["12pm"],
  ($) => $.advertising["1pm"],
  ($) => $.advertising["2pm"],
  ($) => $.advertising["3pm"],
  ($) => $.advertising["4pm"],
  ($) => $.advertising["5pm"],
  ($) => $.advertising["6pm"],
  ($) => $.advertising["7pm"],
  ($) => $.advertising["8pm"],
  ($) => $.advertising["9pm"],
  ($) => $.advertising["10pm"],
  ($) => $.advertising["11pm"],
] as const;
